/**
 * Service de autenticação — backend Kotlin (`/webhook/auth/*`).
 *
 * SEC-2: login (`verify-password` / colaborador) seta cookie HttpOnly;
 * painel usa `credentials: 'include'` + opcional `REACT_APP_N8N_AUTH_HEADER` (dual).
 */
import { apiClient } from "./api/client";

export type SessionMe = {
  ok: boolean;
  authenticated: boolean;
  subject_type?: string;
  user_id?: string;
  company_id?: string;
  cnpj?: string;
  roles?: string[];
  employee_id?: string | null;
  error?: string;
};

export const authService = {
  checkCnpj: (cnpj: string) =>
    apiClient.post<{ exists: boolean; stage?: string }>(
      "/webhook/auth/check-cnpj",
      { cnpj },
      { skipAuth: true }
    ),

  checkCnpjLead: (cnpj: string) =>
    apiClient.post<{ exists: boolean }>(
      "/webhook/auth/check-cnpj-lead",
      { cnpj },
      { skipAuth: true }
    ),

  generateCode: (cnpj: string, email?: string) =>
    apiClient.post<{ status: "ok" }>(
      "/webhook/auth/gerate-code", // typo legado preservado
      { cnpj, email },
      { skipAuth: true }
    ),

  verifyCode: (cnpj: string, code: string) =>
    apiClient.post<{ valid: boolean }>(
      "/webhook/auth/verification-code",
      { cnpj, code },
      { skipAuth: true }
    ),

  createPassword: (cnpj: string, password: string) =>
    apiClient.post<{ status: "ok" }>(
      "/webhook/auth/create-password",
      { cnpj, password },
      { skipAuth: true }
    ),

  /** Login loja — Set-Cookie quando SESSION_AUTH_ENABLED no backend. */
  verifyPassword: (cnpj: string, password: string) =>
    apiClient.post<{
      ok: boolean;
      verified: boolean;
      session_auth?: boolean;
    }>("/webhook/auth/verify-password", { cnpj, password }, {
      skipAuth: true,
      cookieAuth: true,
    }),

  me: () =>
    apiClient.get<SessionMe>("/webhook/auth/me", { cookieAuth: true }),

  refreshCookie: () =>
    apiClient.post<{ ok: boolean; authenticated?: boolean }>(
      "/webhook/auth/refresh",
      undefined,
      { cookieAuth: true }
    ),

  logout: () =>
    apiClient.post<{ ok: boolean }>("/webhook/auth/logout", undefined, {
      cookieAuth: true,
    }),
};

/** @deprecated use authService.verifyPassword — alias de migração AuthContextV2 */
export const loginWithCookie = authService.verifyPassword;

// Colaborador (login separado) — `/webhook/colaboradores/auth-password`
export const collaboratorAuthService = {
  login: (cnpj: string, cpf: string, password: string) =>
    apiClient.post<{ ok?: boolean; verified?: boolean; session_auth?: boolean }>(
      "/webhook/colaboradores/auth-password",
      { cnpj, cpf, password },
      { skipAuth: true, cookieAuth: true }
    ),
};
